import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import ReactLoaderAdvanced from 'react-loader-advanced';
var Loader = function Loader(_ref) {
  var loaded = _ref.loaded,
    children = _ref.children,
    message = _ref.message,
    backgroundStyle = _ref.backgroundStyle;
  return /*#__PURE__*/React.createElement(ReactLoaderAdvanced, {
    show: !loaded,
    message: message === null ? /*#__PURE__*/React.createElement("div", {
      className: "spinner x2"
    }) : message,
    backgroundStyle: _objectSpread({
      backgroundColor: 'rgba(255, 255, 255, 0.55)'
    }, backgroundStyle),
    foregroundStyle: {
      color: '#000'
    }
  }, children);
};
Loader.propTypes = {
  loaded: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  message: PropTypes.node,
  backgroundStyle: PropTypes.shape({})
};
Loader.defaultProps = {
  message: null,
  backgroundStyle: null
};
export default Loader;